// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 992px)","oppositeGenderLink":"_2ejf_ _1R_Wx V16Wa","chevron":"_2ckCQ","link":"Rr6Cq _2h12O _1R_Wx"};